import { Component, OnInit, EventEmitter, Output } from '@angular/core'
import { FormBuilder, FormArray, FormGroup, FormControl } from '@angular/forms'
import { AuthorizeService } from 'app/service/authorize.service'

@Component({
  selector: 'app-set-attendees',
  templateUrl: './set-attendees.component.html',
  styleUrls: ['./set-attendees.component.scss']
})
export class SetAttendeesComponent implements OnInit {
  formGroupOfSetAttendee: FormGroup
  attendee: Array<Object> = []
  setEmployeeList: Array<Object> = []
  setEmployeeSearchResult: Array<Object> = []

  editableFlag = true

  @Output() jointDepartmentEmitter: EventEmitter<String> = new EventEmitter()

  constructor(private fb: FormBuilder, private authorization: AuthorizeService) {}

  ngOnInit() {
    this.formGroupOfSetAttendee = this.fb.group({
      inputNames: this.fb.array([])
    })
  }

  async initialCreate() {
    this.setEmployeeList.map(x => {
      x['label'] = this.prepareSetEmployeeDatalist(x)
      return x
    })
    this.formGroupOfSetAttendee = this.fb.group({
      inputNames: this.fb.array([null, null, null, null])
    })
    this.checkJointDepartment()
  }

  async initialEdit() {
    this.setEmployeeList.map(x => {
      x['label'] = this.prepareSetEmployeeDatalist(x)
      return x
    })
    const setAttendanceArray = new FormArray([])
    this.attendee.forEach(element => {
      element['label'] = this.prepareSetEmployeeDatalist(element)
      element['id'] = element['employeeId']
      setAttendanceArray.push(new FormControl(element))
    })
    if (setAttendanceArray.length < 1) {
      setAttendanceArray.push(new FormControl())
    }
    this.formGroupOfSetAttendee.setControl('inputNames', setAttendanceArray)
    this.checkJointDepartment()
  }

  get setAttendees(): FormArray {
    return this.formGroupOfSetAttendee.get('inputNames') as FormArray
  }

  searchWithMultipleLang(term: string, item: Object) {
    const checkEnglish = /^[a-zA-Z]/.test(term)
    if (checkEnglish) {
      return (item['firstNameEng'] + ' ' + item['lastNameEng'])
        .toUpperCase()
        .startsWith(term.toUpperCase())
    } else {
      return (item['firstNameThai'] + ' ' + item['lastNameThai'])
        .toUpperCase()
        .startsWith(term.toUpperCase())
    }
  }

  prepareSetEmployeeDatalist(employeeElement) {
    return (
      employeeElement.firstNameThai +
      ' ' +
      employeeElement.lastNameThai +
      ' - ' +
      employeeElement.positionName +
      ' - ' +
      employeeElement.departmentShortName
    )
  }

  get getAllSetAttendees(): Array<Object> {
    return this.setAttendees.value
      .filter(element => element !== null)
      .map((element, seq) => {
        return {
          employeeId: element['id'],
          departmentId: element['departmentId'],
          divisionId: element['divisionId'],
          positionId: element['positionId'],
          seq: seq + 1
        }
      })
  }

  removeAttendee(id) {
    this.setAttendees.removeAt(id)
  }

  addAttendee() {
    this.setAttendees.push(new FormControl())
  }

  async checkJointDepartment() {
    this.formGroupOfSetAttendee
      .get('inputNames')
      .valueChanges.debounceTime(500)
      .subscribe(value => {
        const filteredItem = value.filter(x => !!x && x.divisionId !== this.authorization.getUserDivision())
        if ($.unique(filteredItem).length > 0) {
          this.jointDepartmentEmitter.emit('Y')
        } else {
          this.jointDepartmentEmitter.emit('N')
        }
      })
  }

  disableFormControlIfNotPermitted() {
    this.editableFlag = false
    this.formGroupOfSetAttendee.disable()
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/crm/set-attendees/set-attendees.component.ts